import { useProtocolStore } from '@/store/protocolStore'
import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

const CheckoutRoute = lazyRouteComponent(() => import('@/features/checkout/Checkout'), 'Checkout')

export const Route = createFileRoute('/checkout')({
  component: CheckoutRoute,
  beforeLoad: () => {
    const { protocol } = useProtocolStore.getState()
    if (!protocol) {
      throw redirect({ to: '/protocolo' })
    }
  },
})
